import { observable, runInAction } from 'mobx';

import { IUserServices } from 'services/user_services';

export type UiStore = {
  sidebarOpen: boolean;
  submenuOpen: {
    open: boolean;
    id: string;
  };
};

export interface IUiPresenter {
  createStore(): UiStore;
  setSidebarOpen(store: UiStore): Promise<void>;
  setSubmenuOpen(store: UiStore, id: string): Promise<void>;
}

export function createUiPresenter(): IUiPresenter {
  return {
    createStore: (): UiStore =>
      observable({
        sidebarOpen: false,
        submenuOpen: {
          open: false,
          id: '',
        },
      }),
    setSidebarOpen: async (store: UiStore) => {
      try {
        runInAction(() => {
          store.sidebarOpen = !store.sidebarOpen;
        });
      } catch (err) {
        console.log(err);
      }
    },
    setSubmenuOpen: async (store: UiStore, id: string) => {
      try {
        runInAction(() => {
          if (store.submenuOpen.id === id) {
            store.submenuOpen.open = !store.submenuOpen.open;
          } else {
            store.submenuOpen.id = id;
            store.submenuOpen.open = true;
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
  };
}
